import { combineReducers } from 'redux'

import invoices from './invoices'
import clients from './clients'
import auth from './auth'
import profiles from './profiles'
import contents from './contents'

export default combineReducers({ invoices, clients, auth, profiles,contents })